// extracted by mini-css-extract-plugin
export default {"modalAgregarPagoContainer":"EditarPagoComponent_modalAgregarPagoContainer__m2M+X"};